// import React from 'react'

// const RetailerToll = () => {
//   return (
//     <div style={{display:'flex', justifyContent:'center', alignContent:'center', marginTop:'25%', fontWeight:'bold', fontSize:'20px' }}>
//       Coming Soon...
//     </div>
//   )
// }

// export default RetailerToll

import React, { useState } from "react";
import {
  Button,
  TextField,
  Container,
  Grid,
  Typography,
  Box,
  MenuItem,
  CardMedia,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import BBPSLogo from "../Assets/BBPSLogo/NewBBPS.png";
import logo from "../Assets/login/RockkpayLogo.png";
import { NewBBPSIcon } from "../../res/NewWebIcons";

export default function RetailerToll() {
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const formik = useFormik({
    initialValues: {
      operator: "",
      consumerNumber: "",
    },
    validationSchema: Yup.object({
      operator: Yup.string().required("Operator is required"),
      consumerNumber: Yup.string().required("VRN Number is required"),
    }),
    onSubmit: (values) => {
      // Perform form submission logic here
      setSubmitSuccess(true);
    },
  });

  const inputHeight = "56px";

  return (
    <Container maxWidth="lg" style={{ marginTop: "12%", marginBottom: "3%" }}>
      <Box
        mt={4}
        p={4}
        boxShadow={2}
        bgcolor="#DDF1F5"
        borderRadius={8}
        sx={{
          background: "linear-gradient(135deg, #0B1E59 0%, #1840BF 100%)",
          color: "white",
        }}
      >
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} style={{ marginTop: "1%" }}>
            <CardMedia
              component="img"
              image={logo}
              alt="RockkPay Logo"
              style={{
                backgroundColor: "transparent",
                borderRadius: "50%",
                marginBottom: "4%",
              }}
              sx={{
                height: { xs: 50, md: 90 },
                width: { xs: 50, md: 90 },
                mt: { xs: 1, md: 1 },
                marginRight: { xs: "10px", md: "10px" }, // Adjusted to ensure space between logo and text
              }}
            />
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", fontSize: "35px" }}
            >
              Online Toll Payment
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{ fontSize: "20px", marginTop: "5%" }}
            >
              Streamline your routine with hassle-free toll payments, ensuring
              smooth travel every time.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box p={4} bgcolor="white" boxShadow={2} borderRadius={8}>
              <Typography
                variant="h4"
                color="#027BFE"
                sx={{ fontWeight: "bold", fontSize: "30px" }}
              >
                Online Toll Payment
              </Typography>
              <Box display="flex" justifyContent="flex-end">
                <NewBBPSIcon />
              </Box>
              <TextField
                select
                fullWidth
                name="operator"
                label="Operator"
                value={formik.values.operator}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.operator && Boolean(formik.errors.operator)
                }
                helperText={formik.touched.operator && formik.errors.operator}
                style={{ marginTop: "20px" }}
              >
                <MenuItem value="">Select Operator</MenuItem>
                <MenuItem value="Surat Municipal Corporation-water">
                  National Highways Authority of India (NHAI)
                </MenuItem>
                <MenuItem value="Ujjain Nagar Nigam-PHED">
                  Maharashtra State Road Development Corporation (MSRDC)
                </MenuItem>
                <MenuItem value="Urban Improvement Trust(UIT)-BHIWADI">
                  Larsen & Toubro (L&T)
                </MenuItem>
                <MenuItem value="Uttrakhand Jal Sansthan">
                  GMR Infrastructure
                </MenuItem>
                <MenuItem value="Vasai-Virar Municipal Corporation-water">
                  IRB Infrastructure Developers
                </MenuItem>
              </TextField>
              {formik.touched.operator && formik.errors.operator && (
                <Typography variant="body2" color="error">
                  {formik.errors.operator}
                </Typography>
              )}
              <TextField
                fullWidth
                type="text"
                label="VRN Number"
                name="consumerNumber"
                value={formik.values.consumerNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.consumerNumber &&
                  Boolean(formik.errors.consumerNumber)
                }
                helperText={
                  formik.touched.consumerNumber && formik.errors.consumerNumber
                }
                style={{ marginTop: "20px" }}
              />
              <Button
                fullWidth
                type="submit"
                onClick={formik.handleSubmit}
                style={{
                  marginTop: "4%",
                  backgroundColor: "#027BFE",
                  color: "white",
                  textTransform: "none",
                  height: inputHeight,
                  fontSize: 20,
                }}
              >
                Get Details
              </Button>
              {submitSuccess && (
                <Typography
                  variant="body2"
                  style={{ color: "green", marginTop: "20px" }}
                >
                  Bill successfully submitted!
                </Typography>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
